export const hasSycurioPageHeight = ({ data }: MessageEvent) =>
  data.includes('pageHeight');
